export default __webpack_public_path__ + "static/media/Primary-MuitipleChoices.d2904760.svg";